// extracted by mini-css-extract-plugin
export default {"loading":"loading__qXJ1l"};